module.exports = __webpack_public_path__ + "img/page-hd-1.03ab6097.png";